import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { rolesOrder } from "@api";
import { setAlert } from '@store/alerts.reducer';
import { registerRoleBases } from '@/helpers/customRoles';

const showErrorAlert = (dispatch) => {
    dispatch(setAlert({
      title: 'Ошибка',
      text: 'Не удалось загрузить роли',
      type: 'error'
    }));
};

export const fetchAllRoles = createAsyncThunk(
  "allRoles/fetchAllRoles",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await rolesOrder.getList();
      if (response.status !== 200) {
        showErrorAlert(dispatch)
        return rejectWithValue('Ошибка сервера: неверный статус ответа');
      }
      registerRoleBases(response.data);
      return response.data;
    } 
    catch (error) {
        showErrorAlert(dispatch)
        return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

const allRolesSlice = createSlice({
  name: 'allRoles',
  initialState,
  reducers: {
    actionUpdateAllRole(state, action) {
      const { id, role, data } = action.payload ?? {};
      state.data = state.data.map((item) => {
        if (
          (id !== undefined && item.id === id) ||
          (role !== undefined && item.role === role)
        ) {
          return { ...item, ...data };
        }
        return item;
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRoles.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllRoles.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload;
      })
      .addCase(fetchAllRoles.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { actionUpdateAllRole } = allRolesSlice.actions;

export default allRolesSlice.reducer;
